export const GET_CUSTOM_COMP_ID = "GET_CUSTOM_COMP_ID";
export const SET_CUSTOM_COMP_ID = "SET_CUSTOM_COMP_ID";
